import React from 'react';

function Buttons({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      {...otherProps}
    >
      <rect x=".65" y="9.65" width="9.7" height="4.7" rx="1.35" />
      <rect x="13.65" y="9.65" width="9.7" height="4.7" rx="1.35" />
      <path d="M3 12h5" />
    </svg>
  );
}

export default Buttons;
